import axios from 'axios';

const headerfooter = {
  state() {
    return {
        headerHTML: '',
        footerHTML: '',
    }
  },
  mutations: {
    setHeaderHTML(state, headerHTML) {
        state.headerHTML = headerHTML;
    },
    setFooterHTML(state, footerHTML) {
        state.footerHTML = footerHTML;
    },
  },
  getters: {
    headerHTML: (state) => {
        return state.headerHTML
    },
    footerHTML: (state) => {
        return state.footerHTML
    }
  },
  actions: {
    getHeaderHTML(context) {
        const getHeaderHTMLEndpoint = process.env.VUE_APP_AEM_URL + '/bin/mchp/fragmentexport.header.js';
        axios.get(getHeaderHTMLEndpoint).then((response) => {
          if(response.status === 200) {
            const decodedContent = decodeHeader(response.data);
            context.commit('setHeaderHTML', decodedContent);
          } else {
            const error = new Error(response.message);
            throw error;
          }
        }, (error) => {
          console.log(error);
          const getHeaderHTMLFallbackEndpoint = process.env.VUE_APP_FALLBACK_URL + '/FallBackHeadFootFiles/header.js';
          axios.get(getHeaderHTMLFallbackEndpoint).then((response) => {
              if(response.status === 200) {
              const decodedContent = decodeHeader(response.data);
              context.commit('setHeaderHTML',  decodedContent);
              } else {
              const error = new Error(response.message);
              throw error;
              }
          }, (error) => {
              console.log(error);
              context.commit('setHeaderHTML',  '');
          });
        });
    },
    getFooterHTML(context) {
        const getFooterHTMLEndpoint = process.env.VUE_APP_AEM_URL + '/bin/mchp/fragmentexport.footer.js';
        axios.get(getFooterHTMLEndpoint).then((response) => {
            if(response.status === 200) {
            const decodedContent = decodeFooter(response.data);
            context.commit('setFooterHTML',  decodedContent);
            } else {
            const error = new Error(response.message);
            throw error;
            }
            }, (error) => {
            console.log(error);
            const getFooterHTMLFallbackEndpoint = process.env.VUE_APP_FALLBACK_URL + '/FallBackHeadFootFiles/footer.js';
            axios.get(getFooterHTMLFallbackEndpoint).then((response) => {
            if(response.status === 200) {
            const decodedContent = decodeFooter(response.data);
            context.commit('setFooterHTML',decodedContent);
            } else {
            const error = new Error(response.message);
            throw error;
            }
            }, (error) => {
            console.log(error);
            context.commit('setFooterHTML',  '');
            });
        });
    }
  }
};


function decodeHeader(response) {
    response = response.replace('var xfDeliveryObj = ', '');
    response = response.replace(';', '');
    const jsonData = JSON.parse(response);
    const body = document.getElementsByTagName('body')[0];
    const jsLibs = [
      process.env.VUE_APP_AEM_URL + "/etc.clientlibs/mchp/clientlibs/clientlib-base.js",
      process.env.VUE_APP_AEM_URL + "/etc.clientlibs/mchp/clientlibs/clientlib-dependencies.js",
      process.env.VUE_APP_AEM_URL + "/etc.clientlibs/core/wcm/components/commons/site/clientlibs/container.js",
      process.env.VUE_APP_AEM_URL + "/etc.clientlibs/mchp/clientlibs/clientlib-site.js"];
    for(let i = 0; i < jsLibs.length; i++) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = jsLibs[i];
      script.async = false;
      body.appendChild(script);
    }
    let decodedContent = atob(jsonData.content);
    decodedContent = decodedContent.replaceAll('fas ', 'fas fa-solid ');
    decodedContent = decodedContent.replaceAll(' chevron', '');
    decodedContent = decodedContent.replace('http://localhost:4503', process.env.VUE_APP_AEM_URL);
    decodedContent = decodedContent.replaceAll('class="cmp-breadcrumb mc-breadcrumb','class="cmp-breadcrumb mc-breadcrumb d-none"');
    decodedContent = decodedContent.replaceAll('<noscript data-cmp-hook-image="noscript">', '');
    decodedContent = decodedContent.replaceAll('</noscript>', '');
    decodedContent = decodedContent.replaceAll('<a class="nav-link param-chart-icon-nav-link"', '<a class="nav-link param-chart-icon-nav-link inline-block"');
    decodedContent = decodedContent.replaceAll('<a class="subcategory-name nav-link"', '<a class="subcategory-name nav-link inline-block"');
    decodedContent = decodedContent.replaceAll('<a class="nav-link"', '<a class="nav-link inline-block"');
    decodedContent = decodedContent.replaceAll('<i class="far fa-sliders-h', '<i class="far fa-sliders-h family-pro');
    decodedContent = decodedContent.replaceAll('id="paramcharticon"', 'id="mymicrochipparamcharticon"');
    decodedContent = decodedContent.replaceAll('<button id="sitewide-search-submit" type="submit">', '<button id="sitewide-search-submit" type="submit" aria-label="site wide search">');
    decodedContent = decodedContent.replaceAll('tabindex="1"','');
    decodedContent = decodedContent.replaceAll('tabindex="2"','');
    decodedContent = decodedContent.replaceAll('class="cart-icon"','class="cart-icon" aria-label="Go to Shopping Cart"');
    decodedContent = decodedContent.replaceAll("Â", "");
    return decodedContent;
}
  
function decodeFooter(response) {
  response = response.replace('var xfDeliveryObj = ', '');
  response = response.replace(';', '');
  const jsonData = JSON.parse(response);
  let decodedContent = atob(jsonData.content);
  decodedContent = decodedContent.replaceAll("\x92", "'");
  decodedContent = decodedContent.replaceAll("â\x80\x99re", "'re");
  decodedContent = decodedContent.replaceAll("Â", "");
  decodedContent = decodedContent.replaceAll('href="https://www.youtube.com/user/MicrochipTechnology"','href="https://www.youtube.com/user/MicrochipTechnology" aria-label="Microchip Youtube"');
  return decodedContent;
}

export {
    headerfooter
};